import * as yup from 'yup';
import styles from './passwordForm.module.scss';

export const passwordRequirementsPopover = (
  <div className={styles.requirementsContainer}>
    <span>Your password must be:</span>
    <ul className={styles.passwordRequirements}>
      <li>At least 8 characters in length</li>
      <li>Include at least 1 uppercase letter</li>
      <li>Include at least 1 number</li>
      <li>Include one special character (i.e !, $, %, &amp; etc)</li>
    </ul>
  </div>
);

export const SPECIAL_CHAR_REGEX = /[!@#$%^&*()\-_+=[\]{};:'",.<>?/\\|]/;

export const passwordValidation = yup.object().shape({
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Must be at least 8 characters')
    .matches(/[A-Z]/, 'Must include at least 1 uppercase letter')
    .matches(/[0-9]/, 'Must include at least 1 number')
    .matches(SPECIAL_CHAR_REGEX, 'Must include at least 1 special character'),
  confirmPassword: yup
    .string()
    .required('Please confirm your password')
    .oneOf([yup.ref('password')], 'Passwords must match'),
});

export const PASSWORD_RULES = [
  { label: 'At least 8 characters', test: (v: string) => v.length >= 8 },
  { label: 'Include at least 1 uppercase letter', test: (v: string) => /[A-Z]/.test(v) },
  { label: 'Include at least 1 number', test: (v: string) => /[0-9]/.test(v) },
  { label: 'Include at least 1 special character', test: (v: string) => SPECIAL_CHAR_REGEX.test(v) },
];

export const STRENGTH_LEVELS = [
  { label: 'Weak', key: 'weak' },
  { label: 'Fair', key: 'fair' },
  { label: 'Good', key: 'good' },
  { label: 'Strong', key: 'strong' },
];

export const FieldNames = {
  passwordField: 'password',
  confirmPasswordField: 'confirmPassword',
};

export const FieldLabels = {
  PASSWORD: 'NEW PASSWORD',
  CONFIRM_PASSWORD: 'CONFIRM PASSWORD',
};
